module.exports = __webpack_public_path__ + "img/bg2.906f30bb.png";